/**
 * Console design-language tokens — single source of truth.
 *
 * The "Console" language (Linear × PostHog: dense, keyboard, operator-grade)
 * was chosen 2026-06-11 for all analytics/reporting surfaces. The canonical
 * spec lives in the garden skill `jotpsych-analytics-design`; this file is
 * its code counterpart. Change them together or not at all.
 */

export const consoleTokens = {
  /** Primary text — near-black with a violet cast, softer than #000. */
  ink: '#26222E',
  /** Secondary text: labels, meta, muted values. */
  dim: '#8B8696',
  /** Tertiary text: column headers, hints, zero values. */
  fainter: '#B5B1BF',
  /** Structural hairline between regions. */
  line: '#EFEDF3',
  /** Quieter hairline between detail rows. */
  rowLine: '#F6F5F8',
  /** Level-1 group band background. */
  bandBg: '#FAF9FB',
  /** Level-2 sub-band background (quieter than the band). */
  subBandBg: '#FCFCFD',
  /** Filter token / kbd chip background. */
  tokenBg: '#F7F6F9',
  /** Token hover border. */
  tokenHoverBorder: '#D8D4E0',
  /** Token hover background. */
  tokenHoverBg: '#F2F0F6',
  /** Positive deltas, paid status. */
  green: '#1B8A5A',
  /** Negative values, refunds, denied status. */
  red: '#D6453D',
  /** Warning emphasis (unsigned counts, submitted status). */
  amber: '#B89020',
  /** Numerals and code-like text. Always pair with tabular alignment. */
  mono: 'ui-monospace, "SF Mono", SFMono-Regular, Menlo, Consolas, monospace',
} as const;

/** Vertical rhythm in px. Rows are dense by design — do not inflate. */
export const consoleRhythm = {
  commandBar: 48,
  statStrip: 56,
  columnHeader: 30,
  band: 32,
  subBand: 28,
  row: 36,
  footer: 40,
} as const;

/** Default detail rows shown per deepest group before "+N more". */
export const CONSOLE_DISPLAY_CAP = 8;
